<template>
  <div>
    <BreadCrumd
      :title="'Articles'"
      :description="'Création de nouvel article'"
    />
    <div class="mt-4 mb-4">
      <form
        @submit.prevent="submit"
        @keydown="form.onKeydown($event)"
        enctype="multipart/form-data"
      >
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>

        <div class="row">
          <div class="col-md-12 col-lg-3">
            <div class="card mb-n1">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-12">
                    <div
                      class="d-flex flex-column align-items-center justify-content-center text-center"
                    >
                      <img
                        v-if="urlImage"
                        class="rounded-circle"
                        alt="Image"
                        width="200"
                        height="200"
                        :src="urlImage"
                        data-holder-rendered="true"
                      />
                      <img
                        v-else
                        class="rounded-circle"
                        alt="Image"
                        width="200"
                        height="200"
                        :src="URL_LOCAL_FILE + '/images/no-image.png'"
                        data-holder-rendered="true"
                      />
                      <div class="mt-3">
                        <div>
                          <input
                            ref="imageUpload"
                            type="file"
                            style="display: none"
                            accept="image/*"
                            :class="{
                              'is-invalid': form.errors.has('logo'),
                            }"
                            @change="onChangeImage"
                          />
                          <has-error
                            :form="form"
                            field="image"
                            class="mb-4"
                          ></has-error>
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex"
                      :class="
                        urlImage !== null
                          ? 'justify-content-between'
                          : 'justify-content-center'
                      "
                    >
                      <b-button
                        size="sm"
                        variant="outline-custom-primary"
                        @click="chooseImage"
                        ><i class="fas fa-image" aria-hidden="true"></i>
                        Changer
                      </b-button>
                      <b-button
                        v-if="urlImage"
                        size="sm"
                        variant="outline-danger"
                        @click="onClearImage"
                        ><i class="fas fa-trash" aria-hidden="true"></i>
                        Supprimer</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-9">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="type"
                        >Type d'article
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="libelle"
                        :options="articleTypes"
                        :reduce="(type) => type.id"
                        v-model="form.type"
                        placeholder="Type d'articles"
                      >
                        <template v-slot:option="{ libelle }">
                          <h5 style="margin: 0">{{ libelle }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="type"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('type'),
                          }"
                        />
                        <has-error :form="form" field="type"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="reference"
                        >Référence <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('reference'),
                        }"
                        id="reference"
                        v-model="form.reference"
                        type="text"
                        placeholder="Référence"
                        maxlength="30"
                        required
                      />
                      <has-error :form="form" field="reference"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 mt-n4 mt-lg-0">
                    <div class="form-group">
                      <label for="designation"
                        >Désignation <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('designation'),
                        }"
                        id="designation"
                        v-model="form.designation"
                        type="text"
                        placeholder="Désignation"
                        maxlength="50"
                        required
                      />
                      <has-error :form="form" field="designation"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="pays">Pays de provenance / fabrication</label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('pays'),
                        }"
                        id="pays"
                        v-model="form.pays"
                        type="text"
                        placeholder="Pays de provenance / fabrication"
                        maxlength="50"
                      />
                      <has-error :form="form" field="pays"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="famille"
                        >Famille de l'article
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="familles"
                        :reduce="(famille) => famille.uuid"
                        v-model="form.famille"
                        placeholder="Famille de l'article"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="famille"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('famille'),
                          }"
                        />
                        <has-error :form="form" field="famille"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="unite"
                        >Unité de l'article
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="unites"
                        :reduce="(unite) => unite.uuid"
                        v-model="form.unite"
                        placeholder="Unité de l'article"
                      >
                        <template v-slot:option="{ nom, code }">
                          <h5 style="margin: 0">{{ nom }} ( {{ code }} )</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="unite"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('unite'),
                          }"
                        />
                        <has-error :form="form" field="unite"></has-error>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="cout_revient"
                        >Coût de revient
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('cout_revient'),
                        }"
                        id="cout_revient"
                        v-model.number="form.cout_revient"
                        type="text"
                        placeholder="Coût de revient"
                        @focus="$event.target.select()"
                        required
                      />
                      <has-error :form="form" field="cout_revient"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="prix_vente"
                        >Prix de vente <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('prix_vente'),
                        }"
                        id="prix_vente"
                        v-model.number="form.prix_vente"
                        type="text"
                        placeholder="Prix de vente"
                        @focus="$event.target.select()"
                        required
                      />
                      <has-error :form="form" field="prix_vente"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="prix_vente_min"
                        >Prix de vente min
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('prix_vente_min'),
                        }"
                        id="prix_vente_min"
                        v-model.number="form.prix_vente_min"
                        type="text"
                        placeholder="Prix de vente minimum"
                        @focus="$event.target.select()"
                        required
                      />
                      <has-error
                        :form="form"
                        field="prix_vente_min"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="quantite_min"
                        >Quantité min <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('quantite_min'),
                        }"
                        id="quantite_min"
                        v-model.number="form.quantite_min"
                        type="text"
                        placeholder="Quantité min"
                        @focus="$event.target.select()"
                        required
                      />
                      <has-error :form="form" field="quantite_min"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="tva"
                        >TVA général <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('tva'),
                        }"
                        id="tva"
                        v-model.number="form.tva"
                        type="text"
                        placeholder="Taux TVA général"
                        @focus="$event.target.select()"
                        required
                      />
                      <has-error :form="form" field="tva"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="ligne_budgetaire"
                        >Ligne budgétaire
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="ligneBudgetaires"
                        :reduce="(ligneBudgetaire) => ligneBudgetaire.uuid"
                        v-model="form.ligne_budgetaire"
                        placeholder="Ligne budgétaire"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="ligne_budgetaire"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('ligne_budgetaire'),
                          }"
                        />
                        <has-error
                          :form="form"
                          field="ligne_budgetaire"
                        ></has-error>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="compte_comptable_achat"
                        >Compte comptable achat</label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has(
                            'compte_comptable_achat'
                          ),
                        }"
                        id="compte_comptable_achat"
                        v-model="form.compte_comptable_achat"
                        type="text"
                        placeholder="Compte comptable achat"
                      />
                      <has-error
                        :form="form"
                        field="compte_comptable_achat"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="compte_comptable_vente"
                        >Compte comptable vente</label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has(
                            'compte_comptable_vente'
                          ),
                        }"
                        id="compte_comptable_vente"
                        v-model="form.compte_comptable_vente"
                        type="text"
                        placeholder="Compte comptable vente"
                      />
                      <has-error
                        :form="form"
                        field="compte_comptable_vente"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n4">
                    <div class="form-group">
                      <label for="compte_comptable_stock"
                        >Compte comptable stock</label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has(
                            'compte_comptable_stock'
                          ),
                        }"
                        id="compte_comptable_stock"
                        v-model="form.compte_comptable_stock"
                        type="text"
                        placeholder="Compte comptable stock"
                      />
                      <has-error
                        :form="form"
                        field="compte_comptable_stock"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-lg-0 pt-3">
                    <div class="custom-control custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="achat"
                        v-model="form.achat"
                      />
                      <label class="custom-control-label" for="achat"
                        >Disponible pour achat ?</label
                      >
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-lg-0 pt-3">
                    <div class="custom-control custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="vente"
                        v-model="form.vente"
                      />
                      <label class="custom-control-label" for="vente"
                        >Disponible pour vente ?</label
                      >
                    </div>
                  </div>

                  <div
                    class="col-md-6 col-lg-4 mt-lg-0 pt-3"
                    v-if="form.type === 'produits'"
                  >
                    <div class="custom-control custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="lot"
                        v-model="form.lot"
                      />
                      <label class="custom-control-label" for="lot"
                        >Gestion par lot ?</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card" v-if="form.type === 'produits'">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="entrepot"
                        >Entrepôt par défaut
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="entrepots"
                        :reduce="(entrepot) => entrepot.uuid"
                        v-model="form.entrepot"
                        placeholder="Entrepôt par défaut"
                      >
                        <template v-slot:option="{ nom, pays, description }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                          <span v-if="pays" class="d-block">
                            Pays : {{ pays }}
                          </span>
                          <span v-if="description" class="d-block">
                            Description : {{ description }}
                          </span>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="entrepot"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('entrepot'),
                          }"
                        />
                        <has-error :form="form" field="entrepot"></has-error>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="stock_securite"
                        >Stock de sécurité
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('stock_securite'),
                        }"
                        id="stock_securite"
                        v-model.number="form.stock_securite"
                        type="text"
                        placeholder="Stock de sécurité"
                        @focus="$event.target.select()"
                        required
                      />
                      <has-error
                        :form="form"
                        field="stock_securite"
                      ></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="description"
                        >Description (max : 150 caractères )
                      </label>
                      <textarea
                        v-model="form.description"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('description'),
                        }"
                        rows="5"
                        maxlength="150"
                      ></textarea>
                      <has-error :form="form" field="description"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <div class="form-group">
                        <label for="commentaire"
                          >Commentaire (max : 150 caractères )
                        </label>
                        <textarea
                          v-model="form.commentaire"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('commentaire'),
                          }"
                          rows="5"
                          maxlength="150"
                        ></textarea>
                        <has-error :form="form" field="commentaire"></has-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2 mb-4">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router.push({ name: 'gpao_article' }).catch(() => {})
              "
            >
              Liste des articles
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/article_stock/article';
import Form from 'vform';
import { objectToFormData } from 'object-to-formdata';
import config from '@/config';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      form: new Form({
        tva: 0,
        prix_vente: 0,
        quantite_min: 1,
        prix_vente_min: 0,
        unite: null,
        famille: null,
        ligne_budgetaire: null,
        entrepot: null,
        type: null,
      }),
      entrepots: [],
      unites: [],
      familles: [],
      ligneBudgetaires: [],
      urlImage: null,
      cloneId: null,
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      title: 'Gestion des articles - Création',
    };
  },
  watch: {
    $route() {
      this.init();
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('article', ['articleTypes']),
  },
  methods: {
    chooseImage() {
      this.$refs.imageUpload.click();
    },
    onChangeImage(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.urlImage = global.URL.createObjectURL(file);
      this.form.clear_image = false;
    },
    onClearImage() {
      this.form.image = null;
      this.urlImage = null;
      this.form.clear_image = true;
    },
    onChangeType() {
      this.form.entrepot = null;
      this.form.lot = false;
      this.form.stock_securite = null;
    },
    init() {
      this.entrepots = [];
      this.unites = [];
      this.familles = [];
      this.ligneBudgetaires = [];

      if (this.$route.params.cloneId) {
        this.cloneId = this.$route.params.cloneId;

        window.axios
          .all([
            window.axios.get(URL.GET_REQUIREMENTS),
            window.axios.get(URL.ARTICLE + '/' + this.cloneId, {
              params: { edit: true },
            }),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.entrepots = resp1.data.entrepots;
              this.unites = resp1.data.unites;
              this.familles = resp1.data.familles;
              this.ligneBudgetaires = resp1.data.ligne_budgetaires;

              Object.assign(this.form, resp2.data.article);
              delete this.form.resource;
              delete this.form.url_image;
              delete this.form.id;
              delete this.form.uuid;
              if (this.form.type === 'produits') {
                this.form.stock_securite =
                  resp2.data.article.resource.stock_securite;
                this.form.entrepot = resp2.data.article.resource.entrepot;
              }
            })
          )
          .catch();
      } else {
        window.axios
          .get(URL.GET_REQUIREMENTS)
          .then((resp) => {
            this.entrepots = resp.data.entrepots;
            this.unites = resp.data.unites;
            this.familles = resp.data.familles;
            this.ligneBudgetaires = resp.data.ligne_budgetaires;
          })
          .catch();
      }
    },
    submit() {
      this.form
        .post(URL.ARTICLE, {
          transformRequest: [
            function (data) {
              return objectToFormData(data);
            },
          ],
        })
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          if (this.cloneId) {
            this.cloneId = null;
          }
          this.$router.push({
            name: 'achat_article-show',
            params: { id: resp.data.article.id },
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
